import { render, staticRenderFns } from "./shopActivities_editor.vue?vue&type=template&id=e32f938a&scoped=true"
import script from "./shopActivities_editor.vue?vue&type=script&lang=js"
export * from "./shopActivities_editor.vue?vue&type=script&lang=js"
import style0 from "./shopActivities_editor.vue?vue&type=style&index=0&id=e32f938a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32f938a",
  null
  
)

export default component.exports